import { useParams } from "react-router";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { useSummaryItemReport } from "@/services/backend/htz/summary/hooks/use-summary-item-report";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { VisualAssessmentsTable } from "@/services/backend/htz/report/components/visual-assessments-table";
import { ReportVisualAssessmentAddDropdown } from "@/services/backend/htz/report/components/report-visual-assessment-add-dropdown";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";

export function VisualRoute() {
  const { summaryId, itemId } = useParams();
  const { reportId } = useSummaryItemReport(summaryId!, itemId!);
  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! }, { skip: !reportId });

  if (isLoading) {
    return null;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!report) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Visuelle Beurteilung")}</CardTitle>
        <CardDescription>
          {t(
            "Hier werden die einzelnen visuellen Beurteilungen für die Bauteile angezeigt.",
          )}
        </CardDescription>
        <CardAction>
          <ReportVisualAssessmentAddDropdown
            report={report}
            disabled={isImmutable(report)}
          />
        </CardAction>
      </CardHeader>
      <CardContent>
        <VisualAssessmentsTable report={report} />
      </CardContent>
    </Card>
  );
}
